import { gql } from "@apollo/client";

const VNPAY_PAYMENT_RESULT = gql`
  query VnpayPaymentResult($responseData: JSON!) {
    vnpayPaymentReturnUrl(responseData: $responseData) {
      result
      amount
      orderId
      orderDesc
      transactionNo
      responseCode
      message
    }
  }
`;

export default VNPAY_PAYMENT_RESULT;
